/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EntityType/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function EntityType({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/FilterBy/EntityType"
  
}) {
let tabSelectedLedgerTransactionsFilterByValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.transactions.filter_by',
})
let entityTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'entity_type',
path: 'id',
})
let aggregateData = fromAggregate.includes(tabSelectedLedgerTransactionsFilterByValueData, entityTypeIdValueData)
let onClick = fromHelpers.useOnFilterClick({
  children,
  viewPath
  
})
let entityTypeNameValueData = fromData.useDataValue({ viewPath,
context: 'entity_type',
path: 'name',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let entriesValueData = fromData.useDataValue({ viewPath,
context: 'entries',
})
let entityTypeIdValueData1 = fromData.useDataValue({ viewPath,
context: 'entity_type',
path: 'id',
})
let aggregateData1 = fromHelpers.getCount(entriesValueData, entityTypeIdValueData1)
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClick}
 type={aggregateData ? "primary" : "secondary"}
 data="tab.selected.ledger.transactions.filter_by"
 data="entity_type.id"
 aggregate="/Data/aggregate.js includes"
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="entity_type.name"
 text={entityTypeNameValueData}
/>
<TysiaTag
{...childProps}
  viewPath={`${viewPath}/TysiaTag`}
 alignSelf="center"
 type="grey"
 style="filled"
 size="small"
 marginLeft={dtSpaceXxs}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="entries"
 data="entity_type.id"
 aggregate="helpers.js getCount"
 text={aggregateData1}
/>
)}
</TysiaTag>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}